<template>
<!-- 工作台环境详情弹框 -->
	<div style="margin-bottom:30px;">
		<gateway-swiper v-if="modalData3.temperature && modalData3.temperature.length"
			:swiperTitle="'温度'" :swiperData="modalData3.temperature || []" :imgUrlNormal="gateway_env_img_normal1" :imgUrlAbnormal="gateway_env_img_abnormal1">
		</gateway-swiper>
		<gateway-swiper v-if="modalData3.humiture && modalData3.humiture.length"
			:swiperTitle="'湿度'" :swiperData="modalData3.humiture || []" :imgUrlNormal="gateway_env_img_normal2" :imgUrlAbnormal="gateway_env_img_abnormal2">
		</gateway-swiper>
		<gateway-swiper v-if="modalData3.leakages && modalData3.leakages.length"
			:swiperTitle="'水浸'" :swiperData="modalData3.leakages || []" :imgUrlNormal="gateway_env_img_normal3" :imgUrlAbnormal="gateway_env_img_abnormal3">
		</gateway-swiper>
		<gateway-swiper v-if="modalData3.smokes && modalData3.smokes.length"
			:swiperTitle="'烟感'" :swiperData="modalData3.smokes || []" :imgUrlNormal="gateway_env_img_normal4" :imgUrlAbnormal="gateway_env_img_abnormal4">
		</gateway-swiper>
		<gateway-swiper v-if="modalData3.fires && modalData3.fires.length"
			:swiperTitle="'消防'" :swiperData="modalData3.fires || []" :imgUrlNormal="gateway_env_img_normal5" :imgUrlAbnormal="gateway_env_img_abnormal5">
		</gateway-swiper>
		<gateway-swiper v-if="modalData3.lamps && modalData3.lamps.length"
			:swiperTitle="'照明'" :swiperData="modalData3.lamps || []" :imgUrlNormal="gateway_env_img_normal6" :imgUrlAbnormal="gateway_env_img_abnormal6">
		</gateway-swiper>
	</div>
</template>
<script>
// 弹框网关组件swiper
import gatewaySwiper from './gatewaySwiper';
export default {
  name: 'app',
  data(){
    return {
		modalData3: {},
		// 环境温度
		gateway_env_img_normal1: this.$store.state.domain3 + ('plate/温度绿.png'),
		gateway_env_img_abnormal1: this.$store.state.domain3 + ('plate/温度红.png'),
		// 环境湿度
		gateway_env_img_normal2: this.$store.state.domain3 + ('plate/湿度绿.png'),
		gateway_env_img_abnormal2: this.$store.state.domain3 + ('plate/湿度红.png'),	
		// 环境水浸
		gateway_env_img_normal3: this.$store.state.domain3 + ('plate/水浸绿.png'),
		gateway_env_img_abnormal3: this.$store.state.domain3 + ('plate/水浸红.png'),
		// 环境烟感
		gateway_env_img_normal4: this.$store.state.domain3 + ('plate/烟感绿.png'),
		gateway_env_img_abnormal4: this.$store.state.domain3 + ('plate/烟感红.png'),
		// 环境消防
		gateway_env_img_normal5: this.$store.state.domain3 + ('plate/消防绿.png'),
		gateway_env_img_abnormal5: this.$store.state.domain3 + ('plate/消防红.png'),
		// 环境照明
		gateway_env_img_normal6: this.$store.state.domain3 + ('plate/照明绿.png'),
		gateway_env_img_abnormal6: this.$store.state.domain3 + ('plate/照明红.png'),
    }
  },
  mounted(){
    this.$nextTick(()=>{
		this.getData();			
	})
  },
  components:{
		gatewaySwiper
	},
  methods: {
	// 环境
	getData(){
		let valiCodeParams={
			uid:this.getCookie('uid'),
			token:this.getCookie('token'),
			time:Date.parse( new Date()),
			terminalId:4
		};
		
		this.sign2(valiCodeParams);
		this.$ajax.post(this.$store.state.domain2+"/admin/Workbench/environment_list",this.$qs.stringify(valiCodeParams),{
			emulateJSON: true
		}).then(res=>{
			if(res.data.code=="200"){
				this.modalData3 = res.data.data || {};
				// this.$message.success(res.data.msg);
			}else if(res.data.code==10008){
				this.isLogouting = true;
				this.delCookie('username');
				this.$router.push('/login/');
				this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
			}else{
				this.$message.error(res.data.msg);
			}
		});
	},
	
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/comss/modalEnv.vue